import classNames from "classnames";
import { ReactElement } from "react";

import styles from "./LeanButton.module.scss";
import { IconName, LeanIcon } from "./LeanIcon";

export type LeanButtonMode = "primary" | "secondary" | "ghost" | "primaryAlt" | "link";

export interface ILeanButtonProps {
  text?: string;
  mode?: LeanButtonMode;
  icon?: IconName;
  iconLeft?: IconName;
  iconRight?: IconName;
  className?: string;
}

export interface ILeanButtonBaseProps extends ILeanButtonProps {
  render: (className: string, children: ReactElement) => ReactElement;
}

/** Common implementation for Button and LinkButton. Not intented for use in other components. */
export const LeanButtonBase: React.FC<ILeanButtonBaseProps> = ({
  text,
  mode,
  icon,
  iconLeft,
  iconRight,
  className,
  render,
}) => {
  const isIconButton = icon && !text && !iconLeft && !iconRight;

  return render(
    classNames(styles.button, styles[mode || "primary"], isIconButton && styles.iconButton, className),
    <>
      {iconLeft && <LeanIcon className={styles.icon} icon={iconLeft} />}
      {text !== undefined && <div>{text}</div>}
      {mode === "link" && text && <LeanIcon className={styles.icon} icon="ArrowRight" />}
      {(icon || iconRight) && <LeanIcon className={styles.icon} icon={(icon || iconRight)!} />}
    </>
  );
};
